import { LeftOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Col, Form, Input, InputNumber, Modal, Popconfirm, Radio, Row, Table, Tooltip, message } from 'antd';
import type { ColumnsType, TablePaginationConfig } from 'antd/lib/table';
import type { SorterResult } from 'antd/lib/table/interface';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import IndicatorChartBlock from '../../../components/charts/bar/indicator';
import { getEnv } from '../../../helpers/mobx-easy-wrapper';

interface DataType {
  no: string;
  name: string;
  user: string;
}

interface Params {
  pagination?: TablePaginationConfig;
  sorter?: SorterResult<any> | SorterResult<any>[];
  total?: number;
  sortField?: string;
  sortOrder?: string;
}

const columns: ColumnsType<DataType> = [
  {
    title: '专利号',
    dataIndex: 'no',
    width: '20%',
  },
  {
    title: '专利名称',
    dataIndex: 'name',
    width: '50%',
  },
  {
    title: '专利权益人',
    dataIndex: 'user',
  },
];
const getRandomuserParams = (params: Params) => ({
  results: params.pagination?.pageSize,
  page: params.pagination?.current,
  ...params,
});
const scoreStatusMap = {
  0: '未评分',
  1: '草稿',
  2: '已评分',
};

const Score = () => {
  // @ts-ignore
  let { id } = useParams();
  const [judgingsScore, setJudgingsScore] = useState([]);
  const [patentWorks, setPatentWorks] = useState({} as any);
  const [patentList, setPatentList] = useState([]);
  const [patentWorksJudgings, setPatentWorksJudgings] = useState({});
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [showfinals, setShowfinals] = useState(false);
  const [showData, setShowData] = useState(false);
  const [status, setStatus] = useState(2);
  const [calcScore, setCalcScore] = useState();

  const [improvedContent, setImprovedContent] = useState('');
  const [indicator, setIndicator] = useState([]);
  const [vals, setVals] = useState([]);

  const [pagination, setPagination] = useState<TablePaginationConfig>({
    current: 1,
    defaultPageSize: 10,
    showSizeChanger: false,
    hideOnSinglePage: true,
    position: ['bottomCenter'],
  });
  const [container, setContainer] = useState<HTMLDivElement | null>(null);
  const [showSchool, setShowSchool] = useState(false);
  const { apiFactory } = getEnv();

  useEffect(() => {
    let isMounted = true;
    const fetchData = async (params: Params = {}) => {
      const resp = await apiFactory.techService.getScoreDetail(id);

      // chart
      const indicatorData: { name: any; max: number; key: any }[] = [];
      const values: any[] = [];
      resp.judgingsScore.forEach((item: { key: any; title: any; percentage: any }) => {
        indicatorData.push({
          name: item.title,
          max: 10,
          key: item.key,
        });

        values.push(resp.patentWorksJudgings[item.key]);
      });

      const list: { no: any; name: any; user: string }[] = [];
      if(resp.patentWorks.patentName && resp.patentWorks.patentNo && resp.patentWorks.patentUsers) {
        const names = resp.patentWorks.patentName.split(',');
        const nos = resp.patentWorks.patentNo.split(',');
        const users = resp.patentWorks.patentUsers.split(',');
        users.forEach((u: string, i: number) => {
          list.push({
            no: nos[i],
            name: names[i],
            user: u,
          });
        });
      }

      if (isMounted) {
        // resp.patentWorksJudgings.needImproved = resp.patentWorksJudgings.needImproved + '';
        if (resp.patentWorksJudgings.recommended == 1) {
          setShowfinals(true);
        } else {
          setShowfinals(false);
        }
        if (resp.patentWorksJudgings.needImproved == 1) {
          setShowData(true);
        } else {
          setShowData(false);
        }

        form.setFieldsValue(resp.patentWorksJudgings);
        setStatus(resp.patentWorksJudgings.status);
        // @ts-ignore
        setPatentList([...list]);
        setPatentWorks(resp.patentWorks);
        setPatentWorksJudgings(resp.patentWorksJudgings);

        // @ts-ignore
        setJudgingsScore([...resp.judgingsScore]);
        // @ts-ignore
        setIndicator([...indicatorData]);
        // @ts-ignore
        setVals([...values]);
        // @ts-ignore
        setContainer(document.getElementsByTagName('main')[0]);
      }
    };

    fetchData({ pagination });

    return () => {
      isMounted = false;
    };
  }, []);

  const calcTotalScore = () => {
    let totalScore = 0;
    judgingsScore.forEach((score: any) => {
      const value = form.getFieldValue(score.key) ? form.getFieldValue(score.key) : 0;
      totalScore += score.percentage * value;
    });
    // @ts-ignore
    setCalcScore(totalScore.toFixed(2));
  };

  const formValueChange = (changeValue: any) => {
    calcTotalScore();
    if (changeValue.recommended != undefined) {
      if (changeValue.recommended === 1) {
        setShowfinals(true);
      } else {
        setShowfinals(false);
      }
    }

    if (changeValue.needImproved != undefined) {
      if (changeValue.needImproved === 1) {
        setShowData(true);
      } else {
        setShowData(false);
      }
    }

    for (let name in changeValue) {
      indicator.filter((item, index) => {
        // @ts-ignore
        if (name == item.key) {
          const temVals = [...vals];
          // @ts-ignore
          temVals[index] = changeValue[name];
          setVals([...temVals]);
        }
      });
    }
  };
  const { confirm } = Modal;

  const saveData = () => {
    // 草稿
    postData(1);
  };

  const submitData = () => {
    // 提交
    postData(2);
  };
  const postData = async (status: any) => {
    const scoreData = form.getFieldsValue();
    scoreData.patentWorksId = id;
    scoreData.status = status;
    // scoreData.patentWorksId = 1;
    //scoreData.needImproved = scoreData.needImproved.length > 0 ? 1 : 0;
    try {
      const resp = await apiFactory.techService.postScore(scoreData);
      message.success('提交成功');
      window.location.href = '/expert/home';
    } catch (e) {
      if ((e as any).data.status == 500) {
        message.error('提交失败,服务端异常');
      } else {
        message.error('提交失败,请检查提交数据');
      }
    }
  };

  const showTipDialog = () => {
    if (patentWorks.type === '企业') {
      showEnterpriseTip();
    } else {
      showSchoolTip();
    }
  };

  const showSchoolTip = () => {
    Modal.info({
      transitionName: '',
      maskTransitionName: '',
      title: '高校院所组评议标准',
      width: 580,
      okText: '关闭',
      content: (
        <div>
          <p>
            <strong>一、高价值专利条件</strong>
          </p>
          <p>
            <span>具备高价值专利的基本条件，技术水平、生命周期等具备产业化条件 </span>
          </p>
          <p>
            <strong>二、专利运营实施</strong>
          </p>
          <p>
            <span>具备专利运营实施条件，有专利运营实施计划，与产业端、投资端建立了广泛的运营生态，运营实施活跃开展</span>
          </p>
          <p>
            <strong>三、专利技术先进性</strong>
          </p>
          <p>
            <span>与市场普遍的专利技术具有显著的差异化特征，具有突破性特征</span>
          </p>
          <p>
            <strong>四、专利运营团队能力</strong>
          </p>
          <p>
            <span>运营团队具有以市场需求为导向的技术开发能力，对于专利运营有实施计划</span>
          </p>
          <p>
            <strong>五、专利布局及保护</strong>
          </p>
          <p>
            <span>有较清晰的专利保护布局，具有专利防御与进攻等手段计划</span>
          </p>
          <p>
            <strong>六、经济效益</strong>
          </p>
          <p>
            <span>核心专利运营产生的市场效益，含收入、客户反馈</span>
          </p>
          <p>
            <strong>七、社会效益</strong>
          </p>
          <p>
            <span>对社会发展的贡献、行业发展及技术趋势的预期影响、政策适应性</span>
          </p>
          <p>
            <br />
          </p>
        </div>
      ),
      onOk() {},
    });
  };
  const showEnterpriseTip = () => {
    Modal.info({
      transitionName: '',
      maskTransitionName: '',
      title: '企业组评议标准',
      width: 580,
      okText: '关闭',
      content: (
        <div>
          <p>
            <strong>一、高价值专利条件</strong>
          </p>
          <p>
            <span>具备高价值专利的基本条件，技术水平、生命周期等具备产业化条件</span>
          </p>
          <p>
            <strong>二、专利技术先进性</strong>
          </p>
          <p>
            <span>与市场普遍的专利技术具有显著的差异化特征，具有突破性特征</span>
          </p>
          <p>
            <strong>三、专利运营实施</strong>
          </p>
          <p>
            <span>运营团队具有以市场需求为导向的专利运营开展，与市场端、资本端、金融端建立有实施案例</span>
          </p>
          <p>
            <strong>四、经济效益</strong>
          </p>
          <p>
            <span>核心专利运营产生的市场效益，含收入、客户反馈</span>
          </p>
          <p>
            <strong>五、市场影响力</strong>
          </p>
          <p>
            <span>市场占有率，市场地位影响力</span>
          </p>
          <p>
            <strong>六、专利培育布局</strong>
          </p>
          <p>
            <span>专利组合、海外申请、标准相关性、产品关联度、针对竞争对手的布局等，培育布局过程中的规范性、创新方法等</span>
          </p>
          <p>
            <strong>七、社会效益</strong>
          </p>
          <p>
            <span>对社会发展的贡献、行业发展及技术趋势的预期影响、政策适应性</span>
          </p>
          <p>
            <br />
          </p>
        </div>
      ),
      onOk() {},
    });
  };
  // @ts-ignore
  // @ts-ignore
  // @ts-ignore
  return (
    <div className='expertContainer'>
      <Modal
        title='Basic Modal'
        visible={showSchool}
        onOk={() => {
          setShowSchool(false);
        }}
        onCancel={() => {}}
      >
        <p>Some contents...</p>
        <p>Some contents...</p>
        <p>Some contents...</p>
      </Modal>
      <div className={'leftContainer'}>
        <Row>
          <div className={'expert_search'}>
            <div className='backIcon'>
              <LeftOutlined
                onClick={() => {
                  window.location.href = '/expert/home';
                }}
              />
            </div>
            <div className='mainTitle'>
              <div>{(patentWorks as any).worksName}</div>
              <div className='type'>{(patentWorks as any).orgCategory}</div>
            </div>
            <div style={{position:"absolute", right: '40px'}}>
            {(patentWorks as any).prospectusUrl && (
              <div className='downloadLink'>
                <div className={`dropdown`}>
                  <>
                    <a href={(patentWorks as any).prospectusUrl} target='_blank'>
                      商业计划书下载
                    </a>
                    <div className='dropdown__content'>
                      {(patentWorks as any).prospectusUrl &&
                        (patentWorks as any).prospectusUrl.split(',').map((url: string, index: number) => {
                          /* return (<div className={"download_item"}>{url.substring(url.lastIndexOf("/")).length > 20 ?  url.substring(url.length -20) : url.substring(url.lastIndexOf("/"))}</div>)
                                        })*/
                          return (
                            <div className={'download_item'}>
                              <a href={url} target='_blank'>
                                附件_{index + 1}
                              </a>
                            </div>
                          );
                        })}
                    </div>
                  </>
                </div>
              </div>
            )}
            {(patentWorks as any).otherMaterialsUrl && (
              <div className='downloadLink'>
                <div className={`dropdown`}>
                  <>
                    <a href={(patentWorks as any).otherMaterialsUrl} target='_blank'>
                      其他附件下载
                    </a>
                    <div className='dropdown__content'>
                      {(patentWorks as any).otherMaterialsUrl &&
                        (patentWorks as any).otherMaterialsUrl.split(',').map((url: string, index: number) => {
                          /* return (<div className={"download_item"}>{url.substring(url.lastIndexOf("/")).length > 20 ?  url.substring(url.length -20) : url.substring(url.lastIndexOf("/"))}</div>)
                                        })*/
                          return (
                            <div className={'download_item'}>
                              <a href={url} target='_blank'>
                                附件_{index + 1}
                              </a>
                            </div>
                          );
                        })}
                    </div>
                  </>
                </div>
              </div>
            )}
            </div>
          </div>
        </Row>
        <Row style={{ height: `calc(100% - 120px)`, overflowY: 'auto' }}>
          <div className='detail-container' style={{ padding: '0px 25px 25px 25px' }}>
            <Row>
              <h4 style={{ marginTop: '25px' }}>基础信息</h4>
            </Row>
            {patentWorks.orgField && (
              <Row className='basic__row'>
                <label className='itemTitle'>项目领域</label>
                <label className='itemContent'>{(patentWorks as any).orgField}</label>
              </Row>
            )}
            {patentWorks.orgName && (
              <Row className='basic__row'>
                <label className='itemTitle'>单位名称</label>
                <label className='itemContent'>{(patentWorks as any).orgName}</label>
              </Row>
            )}
             {patentWorks.area && (
              <Row className='basic__row'>
                <label className='itemTitle'>所属区县</label>
                <label className='itemContent'>{(patentWorks as any).area}</label>
              </Row>
            )}
            {patentWorks.school && (
              <Row className='basic__row'>
                <label className='itemTitle'>所属学院</label>
                <label className='itemContent'>{(patentWorks as any).school}</label>
              </Row>
            )}
            {patentWorks.orgCategory && (
              <Row className='basic__row'>
                <label className='itemTitle'>单位类型</label>
                <label className='itemContent'>{(patentWorks as any).orgCategory}</label>
              </Row>
            )}
            {patentWorks.transformationType && (
              <Row className='basic__row'>
                <label className='itemTitle'>转化类型</label>
                <label className='itemContent'>{(patentWorks as any).transformationType}</label>
              </Row>
            )}
            {patentWorks.hasOA && (
              <Row className='basic__row'>
                <label className='itemTitle'>是否有运营服务机构</label>
                <label className='itemContent'>{(patentWorks as any).hasOA}</label>
              </Row>
            )}
            {patentWorks.operatingAgency && (
              <Row className='basic__row'>
                <label className='itemTitle'>运营机构</label>
                <label className='itemContent'>{(patentWorks as any).operatingAgency}</label>
              </Row>
            )}
            {
              <Row className='basic__row'>
                <label className='itemTitle'>专利开放许可意愿</label>
                <label className='itemContent'>{(patentWorks as any).isOpen === 1 ? '愿意' : '暂不愿意'}</label>
              </Row>
            }
            {patentWorks.type === '企业' && (
              <Row className='basic__row'>
                <label className='itemTitle'>知识产权质押融资意愿</label>
                <label className='itemContent'>{(patentWorks as any).rightPledge === 1 ? '愿意' : '暂不愿意'}</label>
              </Row>
            )}
            {
              <Row className='basic__row'>
                <label className='itemTitle'>项目路演及投融资意愿</label>
                <label className='itemContent'>{(patentWorks as any).roadshow === 1 ? '愿意' : '暂不愿意'}</label>
              </Row>
            }
            {
              <Row className='basic__row'>
                <label className='itemTitle'>技术转化及交易意愿</label>
                <label className='itemContent'>{(patentWorks as any).techTransfer === 1 ? '愿意' : '暂不愿意'}</label>
              </Row>
            }
            {/* {
              <Row className='basic__row'>
                <label className='itemTitle'>传播意愿（如上技会客厅栏目采访）</label>
                <label className='itemContent'>{(patentWorks as any).disseminate === 1 ? '愿意' : '暂不愿意'}</label>
              </Row>
            } */}
            {
              <Row className='basic__row'>
                <label className='itemTitle'>参赛核心专利数量</label>
                <label className='itemContent'>{(patentWorks as any).patentNum}</label>
              </Row>
            }
            <Row className='basic__row'>
              <hr />
            </Row>
            <Row>
              <h4>专利信息</h4>
            </Row>
            {patentList && (
              <Row className='basic__row'>
                <Table
                  columns={columns}
                  rowKey={(record) => (record as any).no}
                  dataSource={patentList}
                  pagination={pagination}
                  loading={loading}
                  style={{ width: '100%' }}
                  // onChange={handleTableChange as any}
                />
              </Row>
            )}
            {patentWorks.basicInformation && (
              <>
                <Row>
                  <h4>项目简介情况</h4>
                </Row>
                <Row className='score_detail_content'>{(patentWorks as any).basicInformation}</Row>
              </>
            )}

            {patentWorks.coreTechnology && (
              <>
                <Row>
                  <h4>技术情况简介</h4>
                </Row>
                <Row className='score_detail_content'>{(patentWorks as any).coreTechnology}</Row>
              </>
            )}

            {patentWorks.coreTeam && (
              <>
                <Row>
                  <h4>核心团队简介</h4>
                </Row>
                <Row className='score_detail_content'>{(patentWorks as any).coreTeam}</Row>
              </>
            )}
            <Row>
              <h4>
                是否转化
                <span style={{ fontWeight: 'normal', marginLeft: 35, fontSize: '14px' }}>
                  {(patentWorks as any).patentStatus === 0 && '未转化'}
                  {(patentWorks as any).patentStatus === 1 && '已转化'}
                  {[0, 1].indexOf((patentWorks as any).patentStatus) === -1 && '-'}
                </span>
              </h4>
            </Row>

            {patentWorks.economicValue && (
              <>
                <Row>
                  {(patentWorks as any).patentStatus === 0 && <h4>未来加快专利有效实施方案及预计产生的经济价值</h4>}
                  {(patentWorks as any).patentStatus === 1 && <h4>专利转化实施情况及已产生/预计产生的经济价值</h4>}
                </Row>
                <Row className='score_detail_content'>{(patentWorks as any).economicValue}</Row>
              </>
            )}

            {patentWorks.protectionWork && (
              <>
                <Row>
                  <h4>专利转化过程中在布局和保护上的工作</h4>
                </Row>
                <Row className='score_detail_content'>{(patentWorks as any).protectionWork}</Row>
              </>
            )}

            {patentWorks.awardStatus && (
              <>
                <Row>
                  <h4>获奖情况</h4>
                </Row>
                <Row className='score_detail_content'>{(patentWorks as any).awardStatus}</Row>
              </>
            )}
          </div>
        </Row>
      </div>

      <div className={'rightContainer'}>
        <Row>
          <div className='expert_table_header'>
            <div className={'largeBlock'}>
              <div className='stateBox'>
                <div className='title'>总分</div>
                <div className='num'>{calcScore ? calcScore : (patentWorksJudgings as any).score}</div>
              </div>
              <div className='stateBox'>
                <div className='title'>状态</div>
                <div className='num'>{(scoreStatusMap as any)[(patentWorksJudgings as any).status]}</div>
              </div>
            </div>
          </div>
        </Row>
        {/* <Affix target={()=> container}>*/}
        <Row style={{ height: `calc(100% - 120px)` }}>
          <div className='score-form-container'>
            <div>
              评分（1-10）{' '}
              <a style={{ float: 'right', fontSize: '14px' }} onClick={showTipDialog}>
                {' '}
                查看评价体系及规则
              </a>
            </div>
            <div style={{ marginTop: 20 }}>
              <Form form={form} onValuesChange={formValueChange} disabled={status == 2} layout='vertical'>
                <Row>
                  {judgingsScore.map((judgings, index) => {
                    return (
                      <Col key={`judgins_${index}`} span={12}>
                        {/* <label className='form-label'>{(judgings as any).title}</label> */}
                        <Form.Item
                          style={{ width: '90%' }}
                          label={(judgings as any).title}
                          rules={[{ required: true, message: '该选项不能为空' }]}
                          name={(judgings as any).key}
                          validateTrigger={['onSubmit']}
                        >
                          <InputNumber min={0} max={10} style={{ borderRadius: 5 }} />
                        </Form.Item>
                        <Tooltip title={(judgings as any).content}>
                          <QuestionCircleOutlined className='scoreTips' />
                        </Tooltip>
                      </Col>
                    );
                  })}
                </Row>

                <Row className='recommended'>
                  <Col span={24}>
                    <Form.Item
                      label='是否推荐晋级'
                      name='recommended'
                      rules={[
                        {
                          required: true,
                          message: '是否推荐晋级不能为空.',
                        },
                      ]}
                    >
                      <Radio.Group>
                        <Row>
                          <Radio value={1}>推荐晋级</Radio>
                          <Radio value={0}>不推荐晋级</Radio>
                          {/* <Radio value={2} style={{ textAlign: 'left' }}>
                            还需完善资料
                            <Input
                              disabled={disabled}
                              onChange={(e) => setImprovedContent(e.target.value)}
                              value={improvedContent}
                              style={{ width: 140 }}
                              placeholder='请输入完善资料内容'
                            />
                          </Radio> */}
                        </Row>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <Form.Item
                      label='专家意见'
                      name='expertOpinion'
                      rules={[
                        {
                          required: true,
                          whitespace: true,
                          message: '专家意见不能为空.',
                        },
                      ]}
                    >
                      <Input.TextArea autoSize={{ minRows: 3, maxRows: 6 }} placeholder='请输入专家意见' allowClear />
                    </Form.Item>
                  </Col>
                </Row>
                {showfinals && (
                  <Row>
                    <Col span={24}>
                      <Form.Item label='是否需要补充资料' name='needImproved' className='needImproved'>
                        <Radio.Group>
                          <Radio value={1}>需要</Radio>
                          <Radio value={0}>不需要</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                  </Row>
                )}
                {showData && showfinals && (
                  <Row>
                    <Col span={24}>
                      <Form.Item label='补充资料' name='improvedContent'>
                        <Input placeholder='输入需要补充的资料名称' />
                      </Form.Item>
                    </Col>
                  </Row>
                )}
                <Row>
                  <IndicatorChartBlock indicator={indicator} values={vals} />
                </Row>
                {status != 2 && (
                  <Row style={{ justifyContent: 'space-around' }}>
                    <button type='button' className='lite__button' onClick={saveData}>
                      保存草稿
                    </button>
                    <Popconfirm
                      title='提交评分后将无法更改，确认提交评分?'
                      onConfirm={() => {
                        form.validateFields().then(() => {
                          submitData();
                        });
                        // submitData();
                      }}
                      onCancel={() => {}}
                      okText='提交'
                      cancelText='取消'
                    >
                      <button type='button' className='lite__sub__button'>
                        提交内容
                      </button>
                    </Popconfirm>
                  </Row>
                )}
                <Row></Row>
                {/* <Row style={{ fontSize: '14px', justifyContent: 'center', marginTop: 10 }}>查看评价体系及规则</Row> */}
              </Form>
            </div>
          </div>
        </Row>
        {/*  </Affix>*/}
      </div>
    </div>
  );
};

export default Score;
